/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiGetPresignedURLReponseFromJSON(json) {
    return ApiGetPresignedURLReponseFromJSONTyped(json, false);
}
export function ApiGetPresignedURLReponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'readUrl': !exists(json, 'readUrl') ? undefined : json['readUrl'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}
export function ApiGetPresignedURLReponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'readUrl': value.readUrl,
        'url': value.url,
    };
}
